module.exports = __webpack_public_path__ + "static/media/bg4.4bff5d45.jpg";